$(() => {
  // Verifica hash ao iniciar
  URI.init()

  var swiper = new Swiper(".swiper-container", {
    speed: 400,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  })

  // $("#dropdown-rodovias").popover({trigger: 'hover', html: true});

  // $(window).click(function() {
  //     $(".menu-mobile-container").removeClass("open");
  // });

  // $('.menu-mob-bars').click(function(e){
  //     e.stopPropagation();
  //     if ($(".menu-mobile-container").hasClass("open")) {
  //         $(".menu-mobile-container").removeClass("open");
  //     } else {
  //         $(".menu-mobile-container").addClass("open");
  //     }

  //     return false;
  // });

  // $(".disabled-logo").click(function(){
  //     window.location = "/change";
  // });

  // $("#btn-nfc").click(function() {
  //     window.location = "/cupom/index/chave/" + $("#chave-nfc").val();
  // });

  // $("#chave-nfc").keypress(function(e) {
  //     if (e.keyCode == 13) {
  //         $("#btn-nfc").click();
  //     }
  // });
})
